import { put, call, all, takeEvery, takeLatest } from 'redux-saga/effects'
import { withCallback } from 'redux-saga-callback'
import { store as reduxStore } from 'index'
import { push } from 'react-router-redux'
import { message } from 'antd'
import {
  list as usersList,
  add as userAdd,
  get as userGet,
  update as userUpdate,
  del as userDelete,
  search as usersSearch,
  inactiveSearch as usersInactiveSearch,
  friendList as userFriendList,
  groupList as userGroupList,
  authTokenList as userAuthTokenList,
  authTokenDel as userAuthTokenDelete,
  authTokenAdd as userAuthTokenAdd,
  authTokenSearch as userAuthTokensSearch,
  deactivate as userDeactivate,
  activate as userActivate,
  aiAgentUserList as usersAIAgentList,
  updateFriends as userUpdateFriends,
  userSearch as userFriendSearch,
  removeFriends as userRemoveFriends,
  groupSearch as userGroupSearch,
  kickFromGroup as kickUserFromGroup,
  banFromGroup as banUserFromGroup,
  addToGroup as addUserToGroup,
} from 'services/users'
import { list as groupsList, search as groupsSearch } from 'services/groups'
import { manualOutreach } from 'services/user'
import _ from 'lodash'
import constants from 'constants'
import { getAppHost, isAuthErrorCode } from 'helpers'
import actions from './actions'

export function* USERS_LIST({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const filters = payload.filters || {}
    const hasFilters = Object.values(filters).some(v => (Array.isArray(v) ? v.length > 0 : !!v))
    const searchText = hasFilters ? '' : reduxStore.getState().users.userSearchText
    const usersPagination = reduxStore.getState().users.usersListPagination

    let pageNo = payload.currentPage
    if (hasFilters && pageNo === undefined) {
      pageNo = 1
    } else if (pageNo === undefined && usersPagination.current_page !== undefined) {
      pageNo = usersPagination.current_page + 1
    }

    const serviceFilters = { ...filters }
    if (serviceFilters.createdAt && serviceFilters.createdAt.length === 2) {
      const [fromDate, toDate] = serviceFilters.createdAt
      serviceFilters.createdAtFrom = Math.floor(new Date(`${fromDate}T00:00:00`).getTime() / 1000)
      serviceFilters.createdAtTo = Math.floor(new Date(`${toDate}T23:59:59`).getTime() / 1000)
    }
    delete serviceFilters.createdAt

    const success = yield call(
      usersList,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
      searchText,
      0,
      serviceFilters,
    )

    if (success && success.data) {
      let totalUserCount = success.data.length
      let usersListPagination = []
      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        usersListPagination = success.meta.pagination
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          active: payload.data,
          usersList: success.data,
          usersListTotal: totalUserCount,
          usersListPagination,
          areUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          usersList: [],
          usersListTotal: 0,
          usersListPagination: [],
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}


export function* INACTIVE_USERS_LIST({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const filters = payload.filters || {}
    const hasFilters = Object.values(filters).some(v => (Array.isArray(v) ? v.length > 0 : !!v))
    const searchText = hasFilters ? '' : reduxStore.getState().users.userInactiveSearchText
    const usersInactivePagination = reduxStore.getState().users.usersListInactivePagination

    let pageNo = payload.currentPage
    if (hasFilters && pageNo === undefined) {
      pageNo = 1
    } else if (pageNo === undefined && usersInactivePagination.current_page !== undefined) {
      pageNo = usersInactivePagination.current_page + 1
    }

    const serviceFilters = { ...filters }
    if (serviceFilters.createdAt && serviceFilters.createdAt.length === 2) {
      const [fromDate, toDate] = serviceFilters.createdAt
      serviceFilters.createdAtFrom = Math.floor(new Date(`${fromDate}T00:00:00`).getTime() / 1000)
      serviceFilters.createdAtTo = Math.floor(new Date(`${toDate}T23:59:59`).getTime() / 1000)
    }
    delete serviceFilters.createdAt

    const success = yield call(
      usersList,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
      searchText,
      1,
      serviceFilters,
    )

    if (success && success.data) {
      let totalUserCount = success.data.length
      let usersListInactivePagination = []
      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        usersListInactivePagination = success.meta.pagination
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          active: payload.data,
          usersInactiveList: success.data,
          usersListInactiveTotal: totalUserCount,
          usersListInactivePagination,
          areUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          usersInactiveList: success ? success.data : [],
          usersListInactiveTotal: 0,
          usersListInactivePagination: [],
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* GET_USER({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const { id } = payload
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { uAuthTokensListPagination } = reduxStore.getState().users
    const success = yield call(userGet, id, activeApp, getAppHost(appSettings))
    const authTokensRes = yield call(userAuthTokenList, id, activeApp, getAppHost(appSettings))
    const groupsRes = yield call(userGroupList, id, activeApp, getAppHost(appSettings), 1)
    const friendsRes = yield call(userFriendList, id, activeApp, getAppHost(appSettings))
    if (success && success.data) {
      let totalUserGroupCount = groupsRes.data.length
      if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
        totalUserGroupCount =
          groupsRes.meta.pagination.total_pages * groupsRes.meta.pagination.per_page
      }
      let totalUserFriendCount = friendsRes.data.length
      if (friendsRes.meta && friendsRes.meta.pagination && friendsRes.meta.pagination.total_pages) {
        totalUserFriendCount =
          friendsRes.meta.pagination.total_pages * friendsRes.meta.pagination.per_page
      }
      let userNonFriendsList = reduxStore.getState().users.usersList

      if (userNonFriendsList.length > 0) {
        userNonFriendsList = _.filter(userNonFriendsList, function fn(unf) {
          return unf.uid !== id
        })
      }

      let totalUAuthTokenCount = authTokensRes.data.length
      let uAuthTokensPagination = uAuthTokensListPagination
      if (
        authTokensRes.meta &&
        authTokensRes.meta.pagination &&
        authTokensRes.meta.pagination.total_pages
      ) {
        totalUAuthTokenCount =
          authTokensRes.meta.pagination.total_pages * authTokensRes.meta.pagination.per_page
        uAuthTokensPagination = authTokensRes.meta.pagination
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          usersActive: success.data,
          uAuthTokensList: authTokensRes.data,
          uAuthTokensListTotal: totalUAuthTokenCount,
          uAuthTokensListPagination: uAuthTokensPagination,
          uGroupsList: groupsRes.data,
          uGroupsListTotal: totalUserGroupCount,
          uGroupsListPagination: groupsRes.meta.pagination,
          uFriendsList: friendsRes.data,
          uFriendsListTotal: totalUserFriendCount,
          uFriendsListPagination: friendsRes.meta.pagination,
          userNonGroupsList: reduxStore.getState().apps.groupsList,
          userNonFriendsList,
          groupSearchText: '',
          areUsersLoading: false,
        },
      })
    } else {
      yield put(push(`/app/${activeApp.id}/users`))
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* ADD_USER({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const filtered = {}
    _.filter(payload, function fn(n, k) {
      if (payload[k] && _.trim(payload[k]) !== '') {
        filtered[k] = n
      }
    })

    const success = yield call(userAdd, filtered, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.USERS_LIST,
        payload: {
          currentPage: 1,
          filters: {},
          data: activeApp,
          appSettings,
        },
      })

      yield put(push(`/app/${activeApp.id}/users`))
      window.triggerNotification('User added', 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areUsersLoading: false,
        },
      })

      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    }
    return success
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* ENTER_USER_TEXT({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userSearchText: '',
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userSearchText: searchText,
        },
      })

      if (searchText.length === 0) {
        yield put({
          type: actions.USERS_LIST,
          payload: {
            currentPage: 1,
          },
        })
      } else if (searchText.length >= 2) {
        yield put({
          type: actions.SEARCH_USER,
          payload: {},
        })
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* SEARCH_USER() {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const searchText = reduxStore.getState().users.userSearchText

    const success = yield call(usersSearch, activeApp, getAppHost(appSettings), searchText)

    if (success && success.data) {
      let totalUserCount = success.data.length
      let usersListPagination = {}
      if (success.meta && success.meta.pagination && success.meta.pagination.total) {
        totalUserCount = success.meta.pagination.total
      }
      if (success.meta && success.meta.pagination) {
        usersListPagination = success.meta.pagination
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          usersList: success.data,
          usersListTotal: totalUserCount,
          usersListPagination,
          areUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          usersListTotal: 0,
          usersListPagination: {},
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* ENTER_INACTIVE_USER_TEXT({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userInactiveSearchText: '',
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userInactiveSearchText: searchText,
        },
      })

      if (searchText.length === 0 || searchText.length >= 2) {
        yield put({
          type: actions.SEARCH_INACTIVE_USER,
          payload: {},
        })
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* SEARCH_INACTIVE_USER() {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const searchText = reduxStore.getState().users.userInactiveSearchText

    const success = yield call(usersInactiveSearch, activeApp, getAppHost(appSettings), searchText)

    if (success && success.data) {
      let totalUserCount = success.data.length
      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          usersInactiveList: success.data,
          usersListInactiveTotal: totalUserCount,
          usersListInactivePagination: success.meta.pagination,
          areUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          usersListInactiveTotal: 0,
          usersListInactivePagination: {},
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}


export function* UPDATE_USER({ id, payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const filtered = {}
    const unset = []

    _.filter(payload, function fn(n, k) {
      if (payload[k] && _.trim(payload[k]) !== '') {
        filtered[k] = n
      } else if (k === 'tags') {
        filtered.tags = []
      } else unset.push(k)
    })

    filtered.unset = unset

    const success = yield call(userUpdate, id, filtered, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.USERS_LIST,
        payload: { currentPage: 1, data: activeApp, appSettings },
      })

      yield put(push(`/app/${activeApp.id}/users`))
      window.triggerNotification('User saved', 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areUsersLoading: false,
        },
      })
      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* DELETE_USER({ payload }) {
  try {
    const { id, refresh, filters } = payload

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { usersListPagination } = reduxStore.getState().users
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const success = yield call(userDelete, id, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      const userListPageNo =
        usersListPagination !== undefined && usersListPagination.count > 1
          ? usersListPagination.current_page
          : 1
      yield put({
        type: actions.USERS_LIST,
        payload: { currentPage: userListPageNo, filters: filters || {}, data: activeApp, appSettings },
      })
      window.triggerNotification('User Deleted', 'success')
      if (refresh) yield put(push(`/app/${activeApp.id}/users`))
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areUsersLoading: false,
        },
      })
      if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* DEACTIVATE_USER({ payload }) {
  try {
    const { id, refresh, filters } = payload

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { usersListPagination, usersListInactivePagination } = reduxStore.getState().users

    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const success = yield call(userDeactivate, id, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userSearchText: '',
          userInactiveSearchText: '',
        },
      })
      const userListPageNo =
        usersListPagination !== undefined && usersListPagination.count > 1
          ? usersListPagination.current_page
          : 1
      const userInactiveListPageNo =
        usersListInactivePagination !== undefined && usersListInactivePagination.count < 10
          ? usersListInactivePagination.current_page
          : 1
      yield put({
        type: actions.USERS_LIST,
        payload: { currentPage: userListPageNo, filters: filters || {} },
      })
      yield put({
        type: actions.USERS_INACTIVE_LIST,
        payload: { currentPage: userInactiveListPageNo },
      })
      window.triggerNotification('User deactivated', 'success')
      if (refresh) yield put(push(`/app/${activeApp.id}/users`))
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areUsersLoading: false,
        },
      })
      if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* ACTIVATE_USER({ payload }) {
  try {
    const { id, refresh, filters } = payload

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { usersListPagination, usersListInactivePagination } = reduxStore.getState().users

    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const success = yield call(userActivate, id, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userSearchText: '',
          userInactiveSearchText: '',
        },
      })
      const userListPageNo =
        usersListPagination !== undefined && usersListPagination.count < 10
          ? usersListPagination.current_page
          : 1

      const userInactiveListPageNo =
        usersListInactivePagination !== undefined && usersListInactivePagination.count > 1
          ? usersListInactivePagination.current_page
          : 1
      yield put({
        type: actions.USERS_LIST,
        payload: {
          currentPage: userListPageNo,
        },
      })
      yield put({
        type: actions.USERS_INACTIVE_LIST,
        payload: { currentPage: userInactiveListPageNo, filters: filters || {} },
      })
      window.triggerNotification('User activated', 'success')
      if (refresh) yield put(push(`/app/${activeApp.id}/users`))
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areUsersLoading: false,
        },
      })
      if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}


export function* USER_AUTH_TOKENS_LIST({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const uAuthTokensPagination = reduxStore.getState().users.uAuthTokensListPagination

    let pageNo = payload.currentPage
    if (pageNo === undefined && uAuthTokensPagination && uAuthTokensPagination.current_page !== undefined)
      pageNo = uAuthTokensPagination.current_page + 1

    const success = yield call(
      userAuthTokenList,
      reduxStore.getState().users.usersActive.uid,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
    )

    if (success && success.data) {
      let totalUAuthTokenCount = success.data.length
      let uAuthTokensListPagination = []

      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalUAuthTokenCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        uAuthTokensListPagination = success.meta.pagination
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: payload.data,
          uAuthTokensList: success.data,
          uAuthTokensListTotal: totalUAuthTokenCount,
          uAuthTokensListPagination,
          areUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          uAuthTokensList: [],
          uAuthTokensListTotal: 0,
          uAuthTokensListPagination: {},
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* ADD_USER_AUTH_TOKEN({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { uAuthTokensListPagination } = reduxStore.getState().users

    const { uid } = payload

    const success = yield call(userAuthTokenAdd, uid, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      const uAuthTokenListPageNo =
        uAuthTokensListPagination !== undefined &&
        uAuthTokensListPagination.count === uAuthTokensListPagination.per_page
          ? uAuthTokensListPagination.current_page + 1
          : uAuthTokensListPagination.current_page

      yield put({
        type: actions.USER_AUTH_TOKENS_LIST,
        payload: { currentPage: uAuthTokenListPageNo, data: activeApp },
      })

      window.triggerNotification('Auth Token created', 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areUsersLoading: false,
        },
      })

      if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* DELETE_USER_AUTH_TOKEN({ payload }) {
  try {
    const { authToken, uid, refresh } = payload

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { uAuthTokensListPagination } = reduxStore.getState().users

    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const success = yield call(
      userAuthTokenDelete,
      authToken,
      uid,
      activeApp,
      getAppHost(appSettings),
    )

    if (success && success.data) {
      const uAuthTokenListPageNo =
        uAuthTokensListPagination !== undefined && uAuthTokensListPagination.count > 1
          ? uAuthTokensListPagination.current_page
          : 1
      yield put({
        type: actions.USER_AUTH_TOKENS_LIST,
        payload: { currentPage: uAuthTokenListPageNo, data: activeApp },
      })
      window.triggerNotification('Auth Token deleted', 'success')
      if (refresh) yield put(push(`/app/${activeApp.id}/users/user/${uid}`))
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areUsersLoading: false,
        },
      })
      if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* ENTER_UAUTHTOKEN_TEXT({ payload }) {
  try {
    const { searchText } = payload
    yield put({
      type: actions.SET_STATE,
      payload: {
        uAuthTokenSearchText: searchText,
        areUsersLoading: true,
      },
    })
    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: actions.SEARCH_UAUTHTOKEN,
        payload: {},
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* SEARCH_UAUTHTOKEN() {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const activeUser = reduxStore.getState().users.usersActive
    const searchText = reduxStore.getState().users.uAuthTokenSearchText

    const success = yield call(
      userAuthTokensSearch,
      activeUser.uid,
      activeApp,
      getAppHost(appSettings),
      searchText,
    )

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          uAuthTokensList: success.data,
          areUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* IMPORT_USERS_REQUEST_MANUAL_INTENT({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })
    const activeApp = reduxStore.getState().apps.active
    if (!_.isEmpty(activeApp) && activeApp.id !== undefined) {
      const intent = _.join(
        [constants.ManualOutreachIntents['import-users-request'], activeApp.id, payload.importFrom],
        ' / ',
      )
      const post = { intent }

      const success = yield call(manualOutreach, post)
      if (success && success.data) {
        window.triggerNotification(`Response recorded, we'll get back to you soon!`, 'success')
        yield put({
          type: 'settings/CHANGE_SETTING',
          payload: {
            setting: 'visibleModalID',
            value: '',
          },
        })
        yield put({
          type: actions.SET_STATE,
          payload: {
            areUsersLoading: false,
          },
        })
      } else {
        yield put({
          type: actions.SET_STATE,
          payload: {
            areUsersLoading: false,
          },
        })
        if (
          success.error !== undefined &&
          success.error.code !== undefined &&
          isAuthErrorCode(success.error.code)
        ) {
          if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
            yield put({
              type: 'user/LOGOUT',
            })
          } else yield put(push(`/login`))
        } else if (success.error.code === 'ERR_BAD_REQUEST') {
          window.triggerNotification(success.error.details.name, 'error')
        }
      }
      return success
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* SHOW_IMPORT_USER_REQUEST({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        currentIntentRequest: '',
      },
    })
    const { intent: currentIntentRequest } = payload
    yield put({
      type: actions.SET_STATE,
      payload: {
        currentIntentRequest,
      },
    })
    yield put({
      type: 'settings/SET_STATE',
      payload: {
        visibleModalID: 'importUserRequest',
      },
    })
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* AI_AGENT_USER_LIST({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areAIAgentUsersLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const searchText = reduxStore.getState().users.aiAgentUserSearchText
    const usersPagination = reduxStore.getState().users.aiAgentUserListPagination

    let pageNo = payload.currentPage
    if (pageNo === undefined && usersPagination && usersPagination.current_page !== undefined)
      pageNo = usersPagination.current_page + 1
    pageNo = 1
    const success = yield call(
      usersAIAgentList,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
      searchText,
    )

    if (success && success.data) {
      let totalUserCount = success.data.length
      let aiAgentUserListPagination = []
      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        aiAgentUserListPagination = success.meta.pagination
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          active: payload.data,
          aiAgentUserList: success.data,
          aiAgentUserListTotal: totalUserCount,
          aiAgentUserListPagination,
          areAIAgentUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          aiAgentUserList: [],
          aiAgentUserListTotal: 0,
          aiAgentUserListPagination: [],
          areAIAgentUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areAIAgentUsersLoading: false,
      },
    })
  }
}


export function* USER_FRIENDS_LIST({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const searchText = reduxStore.getState().users.userFriendSearchText
    const uFriendsPagination = reduxStore.getState().users.uFriendsListPagination

    let pageNo = payload.currentPage
    if (pageNo === undefined && uFriendsPagination && uFriendsPagination.current_page !== undefined)
      pageNo = uFriendsPagination.current_page + 1

    const success = yield call(
      userFriendList,
      reduxStore.getState().users.usersActive.uid,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
      searchText,
    )
    if (success && success.data) {
      let totalUserFriendCount = success.data.length
      let uFriendsListPagination = []
      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalUserFriendCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        uFriendsListPagination = success.meta.pagination
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          active: payload.data,
          uFriendsList: success.data,
          uFriendsListTotal: totalUserFriendCount,
          uFriendsListPagination,
          areUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          uFriendsList: [],
          uFriendsListTotal: 0,
          uFriendsListPagination: [],
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* ENTER_USER_FRIEND_LIST_TEXT({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userFriendSearchText: '',
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userFriendSearchText: searchText,
          areUsersLoading: true,
        },
      })
      if (searchText.length === 0 || searchText.length >= 2) {
        yield put({
          type: actions.SEARCH_USER_FRIEND_LIST,
          payload: {},
        })
      } else {
        yield put({
          type: actions.SET_STATE,
          payload: {
            areUsersLoading: false,
          },
        })
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* SEARCH_USER_FRIEND_LIST() {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const searchText = reduxStore.getState().users.userFriendSearchText
    const success = yield call(
      userFriendSearch,
      reduxStore.getState().users.usersActive.uid,
      activeApp,
      getAppHost(appSettings),
      searchText,
    )
    if (success && success.data) {
      let userFriendsListTotal = success.data.length

      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        userFriendsListTotal = success.meta.pagination.total_pages * success.meta.pagination.per_page
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          uFriendsList: success.data,
          uFriendsListTotal: userFriendsListTotal,
          uFriendsListPagination: success.meta.pagination,
          areUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          uFriendsListTotal: 0,
          uFriendsListPagination: {},
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* UPDATE_USER_FRIENDS({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { uid, values } = payload
    const { uFriendsList } = reduxStore.getState().users

    const success = yield call(userUpdateFriends, uid, values, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      let unfriendUIDs = []
      _.forEach(uFriendsList, function fn1(f) {
        const checkIndex = _.findIndex(values.accepted, function fn2(a) {
          return a === f.uid
        })
        if (checkIndex < 0) unfriendUIDs = _.concat(unfriendUIDs, f.uid)
      })

      if (unfriendUIDs.length) {
        yield call(userRemoveFriends, uid, unfriendUIDs, activeApp, getAppHost(appSettings))
      }

      const friendsRes = yield call(userFriendList, uid, activeApp, getAppHost(appSettings))

      yield put({
        type: actions.SET_STATE,
        payload: {
          uFriendsList: friendsRes.data,
          areUsersLoading: false,
        },
      })
      window.triggerNotification('Friends updated!', 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areUsersLoading: false,
        },
      })

      if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* ADD_FRIEND_TO_USER({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { uFriendsListPagination } = reduxStore.getState().users
    const { uid } = reduxStore.getState().users.usersActive
    const { addFriendUID } = payload

    const success = yield call(
      userUpdateFriends,
      uid,
      addFriendUID,
      activeApp,
      getAppHost(appSettings),
    )
    if (
      success &&
      success.data &&
      success.data.accepted !== undefined &&
      success.data.accepted[addFriendUID.accepted] !== undefined &&
      success.data.accepted[addFriendUID.accepted].success
    ) {
      const friendsListPageNo =
        uFriendsListPagination !== undefined ? uFriendsListPagination.current_page : 1
      const friendsRes = yield call(
        userFriendList,
        uid,
        activeApp,
        getAppHost(appSettings),
        friendsListPageNo,
      )
      let totalUserFriendCount = friendsRes.data.length
      if (friendsRes.meta && friendsRes.meta.pagination && friendsRes.meta.pagination.total_pages) {
        totalUserFriendCount =
          friendsRes.meta.pagination.total_pages * friendsRes.meta.pagination.per_page
      }

      yield put({
        type: actions.SEARCH_USER_FRIEND,
      })
      yield put({
        type: actions.SET_STATE,
        payload: {
          uFriendsList: friendsRes.data,
          uFriendsListTotal: totalUserFriendCount,
          uFriendsListPagination: friendsRes.meta.pagination,
          areUsersLoading: false,
        },
      })
      window.triggerNotification('Friend added to this user', 'success')
    } else {
      const friendsRes = yield call(userFriendList, uid, activeApp, getAppHost(appSettings))
      let totalUserFriendCount = friendsRes.data.length
      if (friendsRes.meta && friendsRes.meta.pagination && friendsRes.meta.pagination.total_pages) {
        totalUserFriendCount = friendsRes.meta.pagination.total_pages * 10
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          friendUserSearchText: '',
        },
      })
      yield put({
        type: actions.SEARCH_USER_FRIEND,
      })
      yield put({
        type: actions.SET_STATE,
        payload: {
          uFriendsList: friendsRes.data,
          uFriendsListTotal: totalUserFriendCount,
          uFriendsListPagination: friendsRes.meta.pagination,
          areUsersLoading: false,
        },
      })
      if (
        success &&
        success.data &&
        success.data.accepted !== undefined &&
        success.data.accepted[addFriendUID.accepted] !== undefined &&
        !success.data.accepted[addFriendUID.accepted].success &&
        success.data.accepted[addFriendUID.accepted].message !== undefined
      ) {
        window.triggerNotification(success.data.accepted[addFriendUID.accepted].message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    }
    return success
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* ENTER_USER_FRIEND_TEXT({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          friendUserSearchText: '',
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          friendUserSearchText: searchText,
        },
      })
      if (searchText.length === 0 || searchText.length >= 2) {
        yield put({
          type: actions.SEARCH_USER_FRIEND,
        })
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* SEARCH_USER_FRIEND() {
  try {
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const searchText = reduxStore.getState().users.friendUserSearchText
    const { uid } = reduxStore.getState().users.usersActive
    const success = yield call(usersSearch, activeApp, getAppHost(appSettings), searchText)

    if (success && success.data) {
      let userNonFriendsList = success.data
      if (userNonFriendsList.length) {
        userNonFriendsList = _.filter(userNonFriendsList, function fn(unf) {
          return unf.uid !== uid
        })
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          userNonFriendsList,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          userNonFriendsList: [],
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* UNFRIEND_USER({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { uFriendsListPagination } = reduxStore.getState().users
    const { uid } = reduxStore.getState().users.usersActive
    const { friendUID } = payload
    const success = yield call(userRemoveFriends, uid, friendUID, activeApp, getAppHost(appSettings))
    if (success && success.data) {
      const friendsListPageNo =
        uFriendsListPagination !== undefined && uFriendsListPagination.count > 1
          ? uFriendsListPagination.current_page
          : 1

      const friendsRes = yield call(
        userFriendList,
        uid,
        activeApp,
        getAppHost(appSettings),
        friendsListPageNo,
      )
      let totalUserFriendCount = 0
      if (friendsRes.data.length) {
        if (friendsRes.meta && friendsRes.meta.pagination && friendsRes.meta.pagination.total_pages) {
          totalUserFriendCount = friendsRes.meta.pagination.total_pages * 10
        }
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          uFriendsList: friendsRes.data,
          uFriendsListTotal: totalUserFriendCount,
          uFriendsListPagination: friendsRes.meta.pagination,
          areUsersLoading: false,
        },
      })
      window.triggerNotification('User removed as a friend', 'success')
    } else {
      const friendsRes = yield call(userFriendList, uid, activeApp, getAppHost(appSettings))
      let totalUserFriendCount = 0
      if (friendsRes.data.length) {
        if (friendsRes.meta && friendsRes.meta.pagination && friendsRes.meta.pagination.total_pages) {
          totalUserFriendCount =
            friendsRes.meta.pagination.total_pages * friendsRes.meta.pagination.per_page
        }
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          uFriendsList: friendsRes.data,
          uFriendsListTotal: totalUserFriendCount,
          uFriendsListPagination: friendsRes.meta.pagination,
          areUsersLoading: false,
        },
      })
      if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    }
    return success
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* NON_USER_FRIEND_LIST_MODAL({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const searchText = reduxStore.getState().users.nonFriendSearchText
    const nonFriendPagination = reduxStore.getState().users.nonFriendListPagination

    let pageNo = payload.currentPage
    if (pageNo === undefined && nonFriendPagination && nonFriendPagination.current_page !== undefined)
      pageNo = nonFriendPagination.current_page + 1
    if (_.trim(searchText) === '') {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonFriendList: [],
          nonFriendListTotal: 0,
          nonFriendListPagination: {},
          areUsersLoading: false,
        },
      })
      return
    }

    const success = yield call(
      usersList,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
      searchText,
    )

    if (success && success.data) {
      let totalUserCount = success.data.length
      let nonFriendListPagination = []

      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        nonFriendListPagination = success.meta.pagination
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: payload.data,
          nonFriendList: success.data,
          nonFriendListTotal: totalUserCount,
          nonFriendListPagination,
          areUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonFriendList: [],
          nonFriendListTotal: 0,
          nonFriendListPagination: [],
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* ENTER_NON_FRIEND_LIST_TEXT({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonFriendSearchText: '',
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonFriendSearchText: searchText,
          areUsersLoading: true,
        },
      })

      if (searchText.length === 0 || searchText.length >= 2) {
        yield put({
          type: actions.SEARCH_NON_FRIEND_LIST_MODAL,
          payload: {},
        })
      } else {
        yield put({
          type: actions.SET_STATE,
          payload: {
            areUsersLoading: false,
          },
        })
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* SEARCH_NON_FRIEND_LIST_MODAL() {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const searchText = reduxStore.getState().users.nonFriendSearchText
    if (_.trim(searchText) === '') {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonFriendList: [],
          nonFriendListTotal: 0,
          nonFriendListPagination: {},
          areUsersLoading: false,
        },
      })
      return
    }
    const success = yield call(usersSearch, activeApp, getAppHost(appSettings), searchText)

    if (success && success.data) {
      let totalUserCount = success.data.length
      let nonFriendListPagination = []
      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        nonFriendListPagination = success.meta.pagination
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          nonFriendList: success.data,
          nonFriendListTotal: totalUserCount,
          nonFriendListPagination,
          areUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          nonFriendListTotal: 0,
          nonFriendListPagination: [],
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}


export function* USER_GROUPS_LIST({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
        areGroupsLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const searchText = reduxStore.getState().users.groupSearchText
    const groupsPagination = reduxStore.getState().users.groupsListPagination
    const filters = payload.filters || {}

    let pageNo = payload.currentPage
    if (pageNo === undefined && groupsPagination && groupsPagination.current_page !== undefined)
      pageNo = groupsPagination.current_page + 1

    const success = yield call(
      groupsList,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
      searchText,
      filters,
    )

    if (success && success.data) {
      let totalGroupCount = success.data.length
      let groupsListPagination = []

      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalGroupCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        groupsListPagination = success.meta.pagination
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          active: payload.data,
          groupsList: success.data,
          groupsListTotal: totalGroupCount,
          groupsListPagination,
          groupsFilters: filters,
          areUsersLoading: false,
          areGroupsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsList: [],
          groupsListTotal: 0,
          groupsListPagination: [],
          areUsersLoading: false,
          areGroupsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
        areGroupsLoading: false,
      },
    })
  }
}

export function* ENTER_USER_GROUP_LIST_TEXT({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userGroupSearchText: '',
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userGroupSearchText: searchText,
          areUsersLoading: true,
        },
      })
      if (searchText.length === 0 || searchText.length >= 2) {
        yield put({
          type: actions.SEARCH_GROUP_FRIEND_LIST,
          payload: {},
        })
      } else {
        yield put({
          type: actions.SET_STATE,
          payload: {
            areUsersLoading: false,
          },
        })
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* SEARCH_GROUP_FRIEND_LIST() {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const searchText = reduxStore.getState().users.userGroupSearchText
    const success = yield call(
      userGroupSearch,
      reduxStore.getState().users.usersActive.uid,
      activeApp,
      getAppHost(appSettings),
      searchText,
    )

    if (success && success.data) {
      let totalUserGroupCount = success.data.length

      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalUserGroupCount = success.meta.pagination.total_pages * 10
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          uGroupsList: success.data,
          uGroupsListTotal: totalUserGroupCount,
          uGroupsListPagination: success.meta.pagination,
          areUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          uGroupsList: [],
          uGroupsListTotal: 0,
          uGroupsListPagination: {},
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* KICK_USER_FROM_GROUP({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { uGroupsListPagination } = reduxStore.getState().users
    const { uid } = reduxStore.getState().users.usersActive
    const { kickGUID } = payload

    const success = yield call(kickUserFromGroup, uid, kickGUID, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      const groupsListPageNo =
        uGroupsListPagination !== undefined && uGroupsListPagination.count > 1
          ? uGroupsListPagination.current_page
          : 1

      const groupsRes = yield call(
        userGroupList,
        uid,
        activeApp,
        getAppHost(appSettings),
        groupsListPageNo,
      )
      let totalUserGroupCount = 0
      if (groupsRes.data.length) {
        if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
          totalUserGroupCount = groupsRes.meta.pagination.total_pages * 10
        }
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          uGroupsList: groupsRes.data,
          uGroupsListTotal: totalUserGroupCount,
          uGroupsListPagination: groupsRes.meta.pagination,
          areUsersLoading: false,
        },
      })
      window.triggerNotification('User removed from group', 'success')
    } else {
      const groupsRes = yield call(userGroupList, uid, activeApp, getAppHost(appSettings))
      let totalUserGroupCount = 0
      if (groupsRes.data.length) {
        if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
          totalUserGroupCount =
            groupsRes.meta.pagination.total_pages * groupsRes.meta.pagination.per_page
        }
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          uGroupsList: groupsRes.data,
          uGroupsListTotal: totalUserGroupCount,
          uGroupsListPagination: groupsRes.meta.pagination,
          areUsersLoading: false,
        },
      })
      if (success.error.message !== undefined) {
        if (success.error.code === 'ERR_GROUP_NO_CLEARANCE') {
          window.triggerNotification('Owner cannot be kicked', 'error')
        } else {
          window.triggerNotification(success.error.message, 'error')
        }
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    }
    return success
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* BAN_USER_FROM_GROUP({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { uid, name } = reduxStore.getState().users.usersActive
    const { guid } = payload

    const success = yield call(banUserFromGroup, uid, guid, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      const groupsRes = yield call(userGroupList, uid, activeApp, getAppHost(appSettings))
      let totalUserGroupCount = 0
      if (groupsRes.data.length) {
        if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
          totalUserGroupCount = groupsRes.meta.pagination.total_pages * 10
        }
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          uGroupsList: groupsRes.data,
          uGroupsListTotal: totalUserGroupCount,
          uGroupsListPagination: groupsRes.meta.pagination,
          areUsersLoading: false,
        },
      })
      window.triggerNotification(`${name} banned from group`, 'success')
    } else {
      const groupsRes = yield call(userGroupList, uid, activeApp, getAppHost(appSettings))
      let totalUserGroupCount = 0
      if (groupsRes.data.length) {
        if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
          totalUserGroupCount = groupsRes.meta.pagination.total_pages * 10
        }
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          uGroupsList: groupsRes.data,
          uGroupsListTotal: totalUserGroupCount,
          uGroupsListPagination: groupsRes.meta.pagination,
          areUsersLoading: false,
        },
      })
      if (success.error.message !== undefined) {
        if (success.error.code === 'ERR_GROUP_NO_CLEARANCE') {
          window.triggerNotification('Owner cannot be banned', 'error')
        } else {
          window.triggerNotification('Error while banning member', 'error')
        }
      } else {
        window.triggerNotification('Unknown Error', 'error')
      }
    }
    return success
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* ADD_USER_TO_GROUP({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { uGroupsListPagination } = reduxStore.getState().users
    const { uid, name } = reduxStore.getState().users.usersActive
    const { addGUID } = payload

    const success = yield call(addUserToGroup, uid, addGUID, activeApp, getAppHost(appSettings))
    if (
      success &&
      success.data &&
      success.data.participants !== undefined &&
      success.data.participants[uid] !== undefined &&
      success.data.participants[uid].success
    ) {
      const groupsListPageNo =
        uGroupsListPagination !== undefined ? uGroupsListPagination.current_page : 1
      const groupsRes = yield call(
        userGroupList,
        uid,
        activeApp,
        getAppHost(appSettings),
        groupsListPageNo,
      )
      let totalUserGroupCount = groupsRes.data.length
      if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
        totalUserGroupCount = groupsRes.meta.pagination.total_pages * 10
      }

      yield put({
        type: actions.SEARCH_USER_GROUP,
      })
      yield put({
        type: actions.SET_STATE,
        payload: {
          uGroupsList: groupsRes.data,
          uGroupsListTotal: totalUserGroupCount,
          uGroupsListPagination: groupsRes.meta.pagination,
          areUsersLoading: false,
        },
      })
      window.triggerNotification(`${name} added to group`, 'success')
    } else if (
      success &&
      success.data &&
      success.data.participants !== undefined &&
      success.data.participants[uid] !== undefined &&
      !success.data.participants[uid].success
    ) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areUsersLoading: false,
        },
      })
      window.triggerNotification('Already a Member', 'error')
    } else {
      const groupsRes = yield call(userGroupList, uid, activeApp, getAppHost(appSettings))
      let totalUserGroupCount = groupsRes.data.length
      if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
        totalUserGroupCount = groupsRes.meta.pagination.total_pages * 10
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupUserSearchText: '',
        },
      })
      yield put({
        type: actions.SEARCH_USER_GROUP,
      })
      yield put({
        type: actions.SET_STATE,
        payload: {
          uGroupsList: groupsRes.data,
          uGroupsListTotal: totalUserGroupCount,
          uGroupsListPagination: groupsRes.meta.pagination,
          areUsersLoading: false,
        },
      })

      if (success.error.message !== undefined) {
        if (success.error.code === 'ERR_GROUP_NO_CLEARANCE') {
          window.triggerNotification('GROUP ACTION NOT ALLOWED', 'error')
        } else {
          window.triggerNotification(success.error.message, 'error')
        }
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    }
    return success
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* NON_USER_GROUP_LIST_MODAL({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const searchText = reduxStore.getState().users.nonGroupSearchText
    const nonGroupPagination = reduxStore.getState().users.nonGroupListPagination

    let pageNo = payload.currentPage
    if (pageNo === undefined && nonGroupPagination && nonGroupPagination.current_page !== undefined)
      pageNo = nonGroupPagination.current_page + 1
    if (_.trim(searchText) === '') {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonGroupList: [],
          nonGroupListTotal: 0,
          nonGroupListPagination: {},
          areUsersLoading: false,
        },
      })
      return
    }
    const success = yield call(
      groupsList,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
      searchText,
    )

    if (success && success.data) {
      let totalGroupCount = success.data.length
      let nonGroupListPagination = []
      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalGroupCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        nonGroupListPagination = success.meta.pagination
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          active: payload.data,
          nonGroupList: success.data,
          nonGroupListTotal: totalGroupCount,
          nonGroupListPagination,
          areUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonGroupList: [],
          nonGroupListTotal: 0,
          nonGroupListPagination: {},
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* ENTER_NON_GROUP_LIST_TEXT({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonGroupSearchText: '',
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonGroupSearchText: searchText,
          areUsersLoading: true,
        },
      })

      if (searchText.length === 0 || searchText.length >= 2) {
        yield put({
          type: actions.SEARCH_NON_GROUP_LIST_MODAL,
          payload: {},
        })
      } else {
        yield put({
          type: actions.SET_STATE,
          payload: {
            areUsersLoading: false,
          },
        })
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* SEARCH_NON_GROUP_LIST_MODAL() {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const searchText = reduxStore.getState().users.nonGroupSearchText
    if (_.trim(searchText) === '') {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonGroupList: [],
          nonGroupListTotal: 0,
          areUsersLoading: false,
        },
      })
      return
    }
    const success = yield call(groupsSearch, activeApp, getAppHost(appSettings), searchText)
    if (success && success.data) {
      let totalGroupCount = success.data.length
      let nonGroupListPagination = []
      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalGroupCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        nonGroupListPagination = success.meta.pagination
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          nonGroupList: success.data,
          nonGroupListTotal: totalGroupCount,
          nonGroupListPagination,
          areUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          nonGroupList: [],
          nonGroupListTotal: 0,
          nonGroupListPagination: {},
          areUsersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* ENTER_USER_GROUP_TEXT({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupUserSearchText: '',
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupUserSearchText: searchText,
        },
      })
      if (searchText.length === 0 || searchText.length >= 2) {
        yield put({
          type: actions.SEARCH_USER_GROUP,
        })
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export function* SEARCH_USER_GROUP() {
  try {
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const searchText = reduxStore.getState().users.groupUserSearchText

    const success = yield call(groupsSearch, activeApp, getAppHost(appSettings), searchText)

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          userNonGroupsList: success.data,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: activeApp,
          userNonGroupsList: [],
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areUsersLoading: false,
      },
    })
  }
}

export default function* usersSaga() {
  yield all([
    takeEvery(actions.USERS_LIST, USERS_LIST),
    takeEvery(actions.USERS_INACTIVE_LIST, INACTIVE_USERS_LIST),
    takeEvery(actions.ADD_USER, withCallback(ADD_USER)),
    takeEvery(actions.ENTER_USER_TEXT, ENTER_USER_TEXT),
    takeEvery(actions.ENTER_USER_INACTIVE_TEXT, ENTER_INACTIVE_USER_TEXT),
    takeLatest(actions.SEARCH_INACTIVE_USER, SEARCH_INACTIVE_USER),
    takeLatest(actions.SEARCH_USER, SEARCH_USER),
    takeEvery(actions.GET_USER, GET_USER),
    takeEvery(actions.UPDATE_USER, UPDATE_USER),
    takeEvery(actions.DELETE_USER, DELETE_USER),
    takeEvery(actions.DEACTIVATE_USER, DEACTIVATE_USER),
    takeEvery(actions.ACTIVATE_USER, ACTIVATE_USER),
    takeEvery(actions.USER_AUTH_TOKENS_LIST, USER_AUTH_TOKENS_LIST),
    takeEvery(actions.DELETE_USER_AUTH_TOKEN, DELETE_USER_AUTH_TOKEN),
    takeEvery(actions.ADD_USER_AUTH_TOKEN, ADD_USER_AUTH_TOKEN),
    takeEvery(actions.ENTER_UAUTHTOKEN_TEXT, ENTER_UAUTHTOKEN_TEXT),
    takeEvery(actions.SEARCH_UAUTHTOKEN, SEARCH_UAUTHTOKEN),
    takeEvery(actions.UPDATE_USER_FRIENDS, UPDATE_USER_FRIENDS),
    takeEvery(actions.KICK_USER_FROM_GROUP, withCallback(KICK_USER_FROM_GROUP)),
    takeEvery(actions.BAN_USER_FROM_GROUP, withCallback(BAN_USER_FROM_GROUP)),
    takeEvery(actions.ADD_USER_TO_GROUP, withCallback(ADD_USER_TO_GROUP)),
    takeEvery(actions.USER_FRIENDS_LIST, USER_FRIENDS_LIST),
    takeEvery(actions.SEARCH_USER_FRIEND, SEARCH_USER_FRIEND),
    takeEvery(actions.ENTER_USER_FRIEND_TEXT, ENTER_USER_FRIEND_TEXT),
    takeEvery(actions.ADD_FRIEND_TO_USER, withCallback(ADD_FRIEND_TO_USER)),
    takeEvery(actions.UNFRIEND_USER, withCallback(UNFRIEND_USER)),
    takeEvery(actions.ENTER_USER_FRIEND_LIST_TEXT, ENTER_USER_FRIEND_LIST_TEXT),
    takeEvery(actions.SEARCH_USER_FRIEND_LIST, SEARCH_USER_FRIEND_LIST),
    takeEvery(actions.ENTER_USER_GROUP_LIST_TEXT, ENTER_USER_GROUP_LIST_TEXT),
    takeEvery(actions.SEARCH_GROUP_FRIEND_LIST, SEARCH_GROUP_FRIEND_LIST),
    takeEvery(actions.NON_USER_FRIEND_LIST_MODAL, NON_USER_FRIEND_LIST_MODAL),
    takeEvery(actions.ENTER_NON_FRIEND_LIST_TEXT, ENTER_NON_FRIEND_LIST_TEXT),
    takeEvery(actions.SEARCH_NON_FRIEND_LIST_MODAL, SEARCH_NON_FRIEND_LIST_MODAL),
    takeEvery(actions.NON_USER_GROUP_LIST_MODAL, NON_USER_GROUP_LIST_MODAL),
    takeEvery(actions.ENTER_NON_GROUP_LIST_TEXT, ENTER_NON_GROUP_LIST_TEXT),
    takeEvery(actions.SEARCH_NON_GROUP_LIST_MODAL, SEARCH_NON_GROUP_LIST_MODAL),
    takeEvery(actions.SHOW_IMPORT_USER_REQUEST, SHOW_IMPORT_USER_REQUEST),
    takeEvery(actions.IMPORT_USERS_REQUEST_MANUAL_INTENT, withCallback(IMPORT_USERS_REQUEST_MANUAL_INTENT)),
    takeEvery(actions.AI_AGENT_USER_LIST, AI_AGENT_USER_LIST),
    takeEvery(actions.USER_GROUPS_LIST, USER_GROUPS_LIST),
    takeEvery(actions.SEARCH_USER_GROUP, SEARCH_USER_GROUP),
    takeEvery(actions.ENTER_USER_GROUP_TEXT, ENTER_USER_GROUP_TEXT),
  ])
}
